/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExecuteAccountLinkingRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {ExecuteAccountLinkingResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const executeAccountLinking = (request:ExecuteAccountLinkingRequest, options?: CashRequestOptions) => post<ExecuteAccountLinkingRequest, ExecuteAccountLinkingResponse>("/2.0/cash/execute-account-linking", request, {...options, rejectOnError: true })